var FileMode = Object.freeze({
  ReadWrite: "rw",
  ReadOnly: "r",
  WriteOnly: "w",
  Append: "wa",
  Truncate: "wt"
});
export {
  FileMode
};
//# sourceMappingURL=types.js.map
